var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 186,
    viewBox: "0 0 178 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 185,
    transform: "translate(0.503906 0.96994)",
    fill: "url(#pattern0_8_90)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_8_90",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_90",
    transform: "matrix(0.00540541 0 0 0.00517166 0 0.0423083)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8_90",
    width: 185,
    height: 177,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALkAAACxCAYAAACY/hwxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEhSURBVHgB7d2xDcIwFEXRCHaIMkVWBDaDcTJFaG2ELD39xlLOaazf3cL9WxYAAAAAAAAAAAAA4I97e+z7/ljX9b1t23Icx2eZhK6Mrt6tPc7zfLbvLHRldPV+P/mrfWehK6MLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYErW3wp0Zay/DejK6OpZfyvQlbH+BgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFyc9bcCXRnrbwO6Mrp61t8KdGWsvwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXZ/2tQFfG+tuAroyunvW3Al0Z628AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAxVl/K9CVsf42oCujq2f9rUBXxvobAAAAADChL2tS7nDQZdl+AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.af56ce2bfdc953a88397eddc9d03a53a.svg";
export { ForwardRef as ReactComponent };